import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ c("path", {
  "fill-rule": "evenodd",
  d: "M11.704 2.31a.75.75 0 0 1 .591 0l7 3a.75.75 0 0 1 .455.69v9a.752.752 0 0 1-.022.182c-.402 1.607-1.56 2.993-2.923 4.079-1.374 1.093-3.032 1.942-4.57 2.451a.75.75 0 0 1-.47 0c-1.538-.51-3.196-1.358-4.57-2.451-1.363-1.086-2.521-2.472-2.923-4.08A.75.75 0 0 1 4.25 15V6c0-.3.179-.571.455-.69l7-3ZM5.75 9.496v5.408c.182.663.556 1.315 1.077 1.934 1.235-1.733 3.22-2.587 5.173-2.587 1.953 0 3.938.854 5.173 2.587.52-.62.895-1.271 1.077-1.934V9.495L12 6.816 5.75 9.495Zm12.5-1.632L12.295 5.31a.75.75 0 0 0-.59 0L5.75 7.863V6.495L12 3.816l6.25 2.679v1.368ZM16.088 17.91c-.912-1.43-2.483-2.159-4.088-2.159s-3.176.73-4.088 2.16c.071.06.144.119.217.177 1.154.918 2.552 1.654 3.871 2.12 1.32-.466 2.717-1.202 3.87-2.12.074-.058.147-.118.218-.177ZM12 9.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-1.052-1.29a2.75 2.75 0 1 1 2.104 5.08 2.75 2.75 0 0 1-2.104-5.08Z",
  "clip-rule": "evenodd"
}, null, -1), l = [
  n
];
function r(a, d) {
  return e(), t("svg", o, [...l]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
